import React from "react";
import { string, bool } from "prop-types";

import "./input.m.css";

export const InputField = ({ name, placeholder, type = "text", value, required, label, ...props }) => (
  <>
    {(name || label) && <label htmlFor={name} styleName="label" className="sr-only">
      {label !== undefined ? label : name}
    </label>}
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      required={required}
      {...props}
      styleName="input"
    />
  </>
);

InputField.propTypes = {
  name: string,
  placeholder: string,
  type: string,
  value: string,
  required: bool,
  label: string
};
